import { Theme } from '@logto/schemas';
import type { Branding } from '@logto/schemas';

import styles from './index.module.scss';

type Props = {
  readonly className?: string;
  readonly theme: Theme;
  readonly branding: Branding;
};

const PartnerSignature = ({ className, theme, branding }: Props) => {
  const label = branding.partnerPoweredByLabel?.trim() ?? '';
  const href = branding.partnerWebsiteUrl?.trim() ?? '';
  const lightLogo = branding.partnerLogoUrl?.trim() ?? '';
  const darkLogo = branding.partnerDarkLogoUrl?.trim() ?? '';
  const logoSrc = theme === Theme.Dark && darkLogo ? darkLogo : lightLogo || darkLogo;

  if (!label || !href) {
    return null;
  }

  return (
    <div className={className}>
      <a
        aria-label={label}
        className={styles.signature}
        href={href}
        rel="noopener noreferrer"
        target="_blank"
      >
        <span className={styles.text}>{label}</span>
        {logoSrc ? <img alt="" className={styles.logo} src={logoSrc} /> : null}
      </a>
    </div>
  );
};

export default PartnerSignature;
